import { jsxs, jsx } from "react/jsx-runtime";
import { ThumbnailImage, ImageResizeOptions, ImageLoadingBehaviorOptions, Text, TextPriority, Counter, CounterSize } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useCallback } from "react";
import { useConfig } from "../../../contexts/config-context.js";
import { useTranslation } from "../../../contexts/translation-context.js";
import { ImageResizeOptions as ImageResizeOptions$1 } from "../../../field-settings/settings-shared/image/types.js";
import { formatCurrency } from "../../../utils/format-currency.js";
import { getCurrencyAriaLabel } from "../../shared/payment-field-utils.js";
import { st, classes } from "./product-wut.st.css";
const toTPAImageResize = {
  [ImageResizeOptions$1.crop]: ImageResizeOptions.cover,
  [ImageResizeOptions$1.fit]: ImageResizeOptions.contain
};
const ProductWUT = ({
  item,
  imageResize,
  onQuantityChange,
  price = 0,
  hasError,
  quantity = 0
}) => {
  const { currency, regionalFormat } = useConfig();
  const { t } = useTranslation();
  const formattedPrice = formatCurrency({
    amount: price,
    currency: currency?.code,
    locale: regionalFormat
  });
  const currencyTranslation = getCurrencyAriaLabel(t, currency);
  const ariaLabel = `${item.label} ${currencyTranslation} ${price}`;
  const imageAlt = item.media?.image?.altText || item.label || "";
  const setQuantity = useCallback(
    (value) => {
      onQuantityChange?.(value < 0 ? 0 : value);
    },
    [onQuantityChange]
  );
  const onKeyDown = useCallback(
    (event) => {
      if (event.key === "Home") {
        event.preventDefault();
        setQuantity(0);
      }
    },
    [setQuantity]
  );
  return /* @__PURE__ */ jsxs("div", { className: st(classes.root), "data-hook": "product", children: [
    /* @__PURE__ */ jsxs("div", { className: classes.main, children: [
      item.media?.image ? /* @__PURE__ */ jsx("div", { className: classes.image, children: /* @__PURE__ */ jsx(
        ThumbnailImage,
        {
          aspectRatio: "square",
          height: 96,
          width: 96,
          loadingBehavior: ImageLoadingBehaviorOptions.blur,
          resize: toTPAImageResize[imageResize],
          sourceHeight: item.media.image.height,
          sourceWidth: item.media.image.width,
          src: item.media.image.id,
          stretchImage: true,
          alt: imageAlt
        }
      ) }) : null,
      /* @__PURE__ */ jsxs("div", { className: classes.info, children: [
        /* @__PURE__ */ jsx(
          Text,
          {
            "data-hook": "product-label",
            className: classes.productName,
            priority: item.label ? TextPriority.primary : TextPriority.secondary,
            children: item.label || ""
          }
        ),
        /* @__PURE__ */ jsx(
          Text,
          {
            "data-hook": "product-price",
            className: classes.productPrice,
            priority: price !== void 0 ? TextPriority.primary : TextPriority.secondary,
            children: formattedPrice
          }
        )
      ] })
    ] }),
    onQuantityChange ? /* @__PURE__ */ jsx(
      Counter,
      {
        "data-hook": "product-quantity",
        className: classNames(classes.counter, classes.theme, {
          [classes.error]: hasError
        }),
        inputAriaLabel: ariaLabel,
        size: CounterSize.xSmall,
        step: 1,
        min: 0,
        value: quantity,
        onChange: (val) => {
          setQuantity(Number(val));
        },
        error: hasError,
        steppersType: "button",
        onKeyDown
      }
    ) : null
  ] });
};
export {
  ProductWUT
};
//# sourceMappingURL=product-wut.js.map
